/** maximum number of tags for a deviation */
export const MAX_TAG_COUNT = 30;

// note: js version of vms/lib/discoverytags/v./discoverytag.php$296
// $is_valid = strlen($name) < 256 && preg_match('/^[\w\pL]+$/u', $utf8_name);
/** used to `match` tags out of a text string */
const VALID_TAG_REGEX = /[\w\p{L}]+/gu;

/** returns true if `newTag` is not in `existingTags` (using a lowecase compare) */
export function isNewTag(existingTags: string[], newTag: string) {
  for (const existingTag of existingTags) {
    // todo: dubious if this will play nice with unicode
    if (existingTag.toLowerCase() === newTag.toLowerCase()) {
      return false;
    }
  }
  return true;
}

/** splits `text` into valid tags, dedupes vs. `tags`, and returns
 *  as many as will fit with `tags` under MAX_TAG_COUNT */
export function parseTextIntoTags(text: string, tags: string[]): string[] {
  const potentialTags = text.match(VALID_TAG_REGEX) ?? [];
  const deduped = potentialTags.filter(t => isNewTag(tags, t));
  return deduped.slice(0, MAX_TAG_COUNT - tags.length);
}
